/** @jsx jsx */
import { Box } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { AttachmentLike } from "@/data/attachments";

interface ClientPageCoverImageProps {
  image: AttachmentLike;
}

export const ClientPageCoverImage: FC<ClientPageCoverImageProps> = ({ image }) => {
  return (
    <Box
      sx={{
        height: [94, null, null, 316],
        width: "100%",
        maxWidth: 1296,
        m: "0 auto",
        px: [0, null, null, "16px"],
        position: "absolute",
        top: [0, 0, 0, 8],
        left: 0,
        right: 0,
        zIndex: -1,
      }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundImage: `url(${image.publicUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: [0, null, null, 8],
        }}
      />
    </Box>
  );
};
